module.exports = __webpack_public_path__ + "img/paymentScreen.b332635e.png";